/**
 * Constants for Disponibilidad component
 */

export const DISPONIBILIDAD_CONSTANTS = {
    /**
     * Office identification
     */
    OFFICE_IDS: {
        QUERETARO: '18',
        TC_CDMX_FILTER: (oficinaDeOrigen: string) => oficinaDeOrigen !== '18'
    },

    /**
     * Users with special privileges (can change priority)
     */
    PRIVILEGED_USERS: [
        'kTuQOK2N6yY4Zb2BHzeya3jFuT52',
        'mL64yuZTxEUNtqMaSomH46LO0fq2'
    ],

    /**
     * Time intervals in milliseconds
     */
    TIME_INTERVALS: {
        ONE_MINUTE: 60000,
        TWO_MINUTES: 120000,
        FIVE_MINUTES: 300000,
        TEN_MINUTES: 600000,
        THIRTY_MINUTES: 1800000,
        ONE_HOUR: 3600000
    },

    /**
     * Default timer for auto-refresh (5 minutes)
     */
    DEFAULT_TIMER_MS: 300000,

    /**
     * Day names starting with Monday
     */
    DAY_NAMES: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],

    /**
     * Warning thresholds for solicitudes
     */
    WARNING_HOURS: {
        EXPIRING_SOON_MIN: 16,
        EXPIRING_SOON_MAX: 24,
        EXPIRATION_PERIOD: 24
    },

    /**
     * Response time buckets for KPIs (in minutes)
     */
    RESPONSE_TIME_BUCKETS: {
        UNDER_30: 30,
        MIN_30_TO_60: 60,
        H1_TO_2: 120,
        H2_TO_3: 180
    },

    /**
     * Off-hours window excluded from response-time calculations
     */
    OFF_HOURS: {
        START_HOUR: 19,
        END_HOUR: 9
    },

    /**
     * Default date range for searches (in days)
     */
    DEFAULT_SEARCH_RANGE_DAYS: 5,

    /**
     * Default date range for Disponibilidad General (in days)
     */
    DEFAULT_AVAILABILITY_RANGE_DAYS: 7,

    /**
     * Report URLs
     */
    REPORT_URLS: {
        COTIS_PASADAS_POR_DISPOS: 'https://operacion.trosten.com/excel-service/descargarReporteCotisPasadasPorDispos.php',
        SOLICITUDES_DISPONIBILIDAD: 'https://operacion.trosten.com/corp-school/php/admin/excel-service/descargarSolicitudesDisponibilidad.php'
    }
};



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/disponibilidad/disponibilidad.constants.ts